import React, { Component } from 'react';
import { connect } from 'react-redux';
import NoAvailableRecordComponent from '../FloatingSideComponents/NoAvailableRecordComponent';
import { CUSTOM_COMPONENTS } from '../../../js/customElements/customComponents';
import { DRAGGABLE_WINDOWS, WORKBAR_ACTIONS } from '../../../constants'
import { noAvailableRecordIcon } from '../../../Images/NoAvailableSVG';
import { removeWorkAction } from '../../../redux/actions/A_workBar_selected'
import { removeWindow } from '../../../redux/actions/A_draggable_windows_controller'
import { Singleton } from '../../../js/Singleton';
import { SingletonSharedData } from '../../../js/singletonSharedData';

class NoAvailableRecordFloating extends Component{
  constructor(props){
    super(props);
    this.language = new Singleton();
    this.sharedData = new SingletonSharedData();
  }

  closeChat(){
    this.props.removeWorkAction(WORKBAR_ACTIONS.NO_AVAILABLE_RECORD);
    this.props.removeWindow(DRAGGABLE_WINDOWS.NO_AVAILABLE_RECORD);
    this.sharedData.setStateWindow(DRAGGABLE_WINDOWS.NO_AVAILABLE_RECORD, false);
  }
  render() {
    return (
        <div className={`fullSize ${!this.props.simultaneosRecs ? 'regsMultiple' : ''} `} onClick={()=>this.props.goTopZ(this.props.id)}>
          {CUSTOM_COMPONENTS["draggableHeader"](noAvailableRecordIcon,
                                              this.language.getText("GUICommonMenudisableHistory"),
                                              ()=>this.closeChat())}
          <NoAvailableRecordComponent
          floating={false}/>
        </div>
      
    );
  }
}
function mapStateToProps(state) {
  return { 
    simultaneosRecs: state.preview.simultaneosRecs
  }
}
function mapDispatchToProps(dispatch) {
  return ({
    removeWorkAction : (idRemove) => {dispatch(removeWorkAction(idRemove));},
    removeWindow: (iDdragComponent) => { dispatch(removeWindow(iDdragComponent)); },
  });
}
export default NoAvailableRecordFloating = connect(
  mapStateToProps,
  mapDispatchToProps
)(NoAvailableRecordFloating);



// WEBPACK FOOTER //
// ./src/components/workSpace/floatingWindows/NoAvailableRecordFloating.jsx